<template>
  <div class="chartElem">
    <div class="row">
      <highcharts ref="hc" class="chart" :options="chartOptions" :updateArgs="updateArgs"></highcharts>
    </div>
  </div>
</template>

<script>
export default {
    name: "MultipleN",
    data: () => ({
      _resizeObserver: null,
      cursos: [
            'Materno',
            'Niño',
            'Adolescente',
            'Joven',
            'Adulto',
            'Adulto Mayor', 
        ],
        titulos: [
            'Cuidado Integral de la Gestante',
            'Cuidado Integral del Niño',
            'Cuidado Integral del Adolescente',
            'Cuidado Integral del Joven',
            'Cuidado Integral del Adulto',
            'Cuidado Integral del Adulto Mayor', 
        ],
        grupos: [
            'NEONATO',
            'MENOR DE 1 AÑO',
            '1 AÑO',
            '2 AÑOS',
            '3 AÑOS',
            '4 AÑOS',
            'DE 5 a 11 AÑOS',
            '36 MESES'
        ],
      title: {
        color: '#FF00FF',
        fontWeight: 'bold',
        size: '10px',
        style: {
            wordWrap: 'break-word',
            'text-align': 'center'
          }
      },
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: 'Spline',
      seriesColor: '#6fcd98',
      colorInputIsSupported: null,
      animationDuration: 1000,
      updateArgs: [true, true, {duration: 1000}],
      chartOptions: {
        chart: {
            type: 'line',
            reflow: true,
        },
        title: {
          text: 'Avance Acumulado',
          color: '#FF00FF',
          fontWeight: 'bold',
          size: '10px',
          style: {
            wordWrap: 'break-word',
            'text-align': 'center'
          }
        },

        xAxis: {
            categories: [],
            tickmarkPlacement: 'on',
            lineWidth: 0,
        },

        yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            title: {
            text: 'Avance (%)'
            }
        },

        plotOptions: {
            area: {
                dataLabels: {
                    enabled: true,
                    color: 'black'
                },
            }
        },

        tooltip: {
            headerFormat: '<b>{series.name}</b><br/>',
            pointFormat: '{point.category}: {point.y}%'
        },

        legend: {
        },

        series: [{
            name: '% de Avance Acumulado',
            data: [],
            color: '#33C1FF',
            pointPlacement: 'on',
            type: 'line',
            dataLabels: {
                enabled: true,
                format: '{point.y} %',
                style: {
                  fontSize: '10px',
                  borderColor: "red",
                }
            },
        }],

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                }
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 600,
                },
                chartOptions: {
                    chart: {
                        height: 260,
                        spacing: [10, 10, 10, 10],
                        scrollablePlotArea: {
                            minWidth: 560,
                            scrollPositionX: 0
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal',
                        itemStyle: {
                            fontSize: '10px'
                        }
                    },
                    xAxis: {
                        labels: {
                            style: {
                                fontSize: '9px'
                            }
                        }
                    },
                    yAxis: {
                        labels: {
                            style: {
                                fontSize: '9px'
                            }
                        }
                    },
                    series: [{
                        dataLabels: {
                            enabled: false
                        }
                    }]
                }
            }]
        }
      },
  }),
  created () {
    this.getIniciar()
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(() => {
          this.reflowChart()
        })
        this._resizeObserver.observe(this.$el)
      }
      window.addEventListener('resize', this.reflowChart, { passive: true })
      this.reflowChart()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reflowChart)
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
      this._resizeObserver = null
    }
  },
  props: ['serie','numerador','avance','titulo'],
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  methods: {
    reflowChart() {
      const chart = this.$refs.hc && this.$refs.hc.chart
      if (chart && typeof chart.reflow === 'function') {
        chart.reflow()
      }
    },
    getIniciar() {
      this.chartOptions.title.text = this.titulo+' (% Avance Acumulado)'
      this.chartOptions.xAxis.categories = this.serie
      this.chartOptions.series[0].data = this.avance
    },
  }
}
</script>

<style scoped>
 .chartElem {
     width: 100%;
 }

 .chart {
     width: 100%;
 }
</style>
